//-------------------------------------------------------------------------------------
//                             Copyright(c) 2024
//-------------------------------------------------------------------------------------
//  Abstract:
//		基于i18n的多国语言切换表-中文表
//-------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------>
const en_US = {
	// 公共
	commom: {
		username: 'User name',
		usernamePlaceholder: 'Please enter username/email address',
		password: 'Password',
		passwordPlaceholder: 'Please enter password',
		passwordLengthWram: 'Please enter a password of at least 8 characters in length',
		passwordEmpty: 'Password or confirmation password cannot be empty',
		passwordNot: 'Password inconsistency',
		confirmPassword: 'Confirm password',
		confirmPasswordPlaceholder: 'Confirm password',
		email: 'E-mail',
		emailPlaceholder: 'Please enter your email address',
		code: 'Code',
		codePlaceholder: 'Please enter the verification code',
		emailError: 'Incorrect email format',
		sendSuccess: 'Successfully sent, please check your inbox',
		sendCode: 'Obtain verification code',
		codeError: 'Please enter the verification code or email format is incorrect',
		close: 'close',
		menu: 'Menu',
		isnull:'Null',
		saveSuccess:'Save success',
		sysErr:'System exception, please try again later',
		component:'Component',
		resource:'Resource',
		language:'Language',
		category:'Category',
		deleteSucess: 'Delete successful',
		ok:'Submit',
		cancel:'Cancel',
		select:'Select',
		date:'Date',
		add:'Add',
		downloadLoadingText:"Please wait..",
		view:'View',
		selectPlaceholder:"Select",
		editorPlaceholder:"Please enter...",
		qsPlaceholder:"Please enter your question",
		productSeries:"Product Series",
		noPermission:"No permission!"
	},
	search:{
		product:"Product",
		package:"Product Version",
		document:"Document",
		train:"Train",
		faq:"Questions",
		activity:"Activity",
		keyPlaceholder:"Please enter keywords for search",
		category:"Category",
		categoryTitle:"Category",
		result_p1:"您在",
		result_p2:"中",
		result_p3:"搜索",
		result_p4:"共获得",
		result_p5:"个结果"
	},
	filter:{
		bynew:'New',
		byold:'Earliest',
		bytitle:"Title",
		byhits:'Hits',
		byweight:'Weight',
		search:'Search',
		reset:'Reset',
		searchPlaceholder:'Please enter keywords for search',
		page:'Show{a}-{b}  Total {c}',//显示1-10 共60
		pageSize:'{a}/page'//10个/页
	},
	// 登录
	login: {
		title: 'Login',
		titleTip: 'Log in to your account to manage your personal center',
		remmenber: 'Remember login password',
		forgotPassword: 'Forgot password',
		registerNow: 'Register Now',
		noAccount: 'No account',
		usernameEmpty: 'User name/password cannot be empty',
		success: 'Login succeeded'
	},
	//产品
	product:{
		package:"Package",
		document:"Document",
		question:"Questions",
		train:"Train",
		updateTime:"Update Time",
		relations:"Related products",
		feedback:"Feedback",
		feedbackInfo:"Describe the issues you have encountered with your current product and provide feedback to the platform for resolution.",
		feedbackBtn:"Submit",
		knowledge:"Knowledge"
	},
	ipproduct:{
		ip:"IP Product"
	},
	// 注册
	register: {
		title: 'Register',
		titleTip: 'Register your account to manage your personal center',
		nextSetp: 'Next step',
		backLogin: 'Return to login',
		siteId: 'Pleast Enter Site ID',
		siteIdPlaceholder: 'Pleast Enter Site ID',
		noSiteId: 'No Site ID',
		improveInformation: 'Improve personal information',
		tRIAL: 'TRIAL',
		loginTip: 'Complete it later in the personal center, directly',
		tRIALTip: 'Please complete your personal information and select products that interest you',
		company: 'Your company',
		companyPlaceholder: 'Please enter your company name',
		name: 'Your first name',
		namePlaceholder: 'Please enter your first name',
		surname: 'Your surname',
		surnamePlaceholder: 'Please enter your last name',
		country: 'Your Country',
		countryPlaceholder: 'Please enter your country',
		province: 'Your state/province',
		provincePlaceholder: 'Please enter your state/province',
		city: 'Your city',
		cityPlaceholder: 'Please enter your city',
		encoded: 'Postal code of the location',
		encodedPlaceholder: 'Please enter your postal code',
		address: 'Address',
		addressPlaceholder: 'Please enter detailed address',
		companyAddress: 'Company detailed address',
		companyAddressPlaceholder: "Please enter your company's detailed address",
		contact: 'Contact information',
		contactPlaceholder: 'Please enter your contact information',
		interestedProduct: 'Products of interest',
		siteIdError: 'Pleast Enter Site ID',
		saveLogin: 'Successfully saved, return to login',
		save:"Save"
	},
	// 找回密码
	findPassword: {
		title: 'Retrieve password',
		titleTip: 'Retrieve password based on email',
		newPassword: 'Enter a new password',
		submit: 'Submit',
		changeSuccess: 'Modified successfully'
	},
	// 头部菜单
	topMenu: {
		product: 'Product',
		documentDownload: 'Document Download',
		onlineTraining: 'Online Training',
		frequentlyAskedQuestion: 'Questions',
		activity: 'Activity',
		operationTraining: 'Operation training'
	},
	feedback:{
		process1:'Submit Feedback',
		process2:'Data review',
		process3:'Processing results',
		questionType:"Question type",
		selectQuestionType:"Select product and question type",
		selectType:"Select type",
		required:"Remarks marked with * are mandatory items",
		productName:"Product Name",
		selectProductName:"Select a product",
		version:"Version",
		selectVersion:"Select Version",
		basicInformation:"Basic Information",
		tip:"Provide more detailed information to make a more accurate understanding of your needs.",
		questionDesc:"Problem Summary",
		titlePlaceholder:"Please enter a title",
		content:"Details",
		contentPlaceholder:"Please describe your issue",
		additionalInformation:"additional information",
		additionalInformationTip:"Supplementary materials are information resources directly related to the problem.",
		attachments:"Upload attachments",
		uploadImage:"Add Picture",
		submit:"Submit",
		enterProductName: 'Please select a product name',
		selectVision: 'Please select a version number',
		selectQuestionType: 'Please select the type of question',
		writeQuestion:'Please provide an overview of the problem',
		writeDetail: 'Please provide a detailed description',
		adminExamine: 'Successfully submitted, waiting for administrator review',
		problemDesc:'Problem description',
		submitDate:"Submission date",
		type:'Problem type',
		attach:"Attachments",
		ExpectedPriority:'Expected Priority',
		ExpectedResolutionTime:"Expected Resolution Time",
		updateTime:'Update Time',
		createDate:"Create Time",
		proName:"Product Name and Version Number",
		productOrIp:"IP Project/Product Name"
	},
	// 前台
	show: {
		newProduct: 'New Product',
		more: 'More',
		newDocument: 'New Document',
		newTrain: 'New Train',
		newActivity: 'New Activity',
		noStart: 'Not started',
		entrying: 'Entrying',
		end: 'Ended',
		lookDetail: 'Detail',
		category:'Category',
		brief:"Brief",
		relatedDownloads:'Related downloads',
		prev:'Prev',
		next:'Next',
		directory:'Directory',
		relatedTraining:'Related Training',
		loginAndRegister:"Login/Register",
		activityDate:"Activity Date",
		registrationDate:"Registration Date",
		activityType:"Activity Type",
		offlineActivity:'Offline',
		onlineActivity:'Online'
	},
	activity:{
		notStarted:'Not started',
		inProgress:"Entrying",
		ended:"Ended",
		resource:"Article source",
		eventRegistration:"Event Registration",
		tip:"Fill out the form to register for the event",
		requireTip:"( Remarks marked with * are mandatory items )",
		name:"Name",
		namePlaceholder:"Please enter your name",
		phone:"Phone",
		phonePlaceholder:"Please enter your phone number",
		email:"Email",
		emailPlaceholder:"Please enter email",
		emailRex:"Incorrect email format",
		company:"Company",
		companyPlaceholder:"Please enter the company name",
		post:"Position",
		selectPost:"Please select a position",
		industry:"Industry",
		selectIndustry:"Please select an industry",
		aggree:"I read and agree",
		aggreed:"I have read and agree",
		submit:"Submit",
		close:"Close",
		activityEnded:"Activity Ended",
		success:"Event registration successful",
		pleaseRead:"Please read and agree"
	},
	qa:{
		brief:"Brief",
		detail:"Detail",
		relateDownload:"Related Download",
		relate:"Related issues"
	},
	// 后台菜单
	adminMenu: {
		home:'Personal',
		information: 'Information',
		password: 'Change password',
		product: 'My product',
		download: 'Download Record',
		entry: 'Registration Record',
		feedback: 'Feedback',
		ip: 'IP Product'
	},
	// 后台
	admin: {
		exit: 'Exit',
		slogan: 'Welcome to the platform',
		website: 'Home',
		messageCenter: 'Message center',
		confirmNewPassword: 'Confirm new password',
		emailCode: 'Email verification code',
		save: 'Save',
		passwordPlaceholder: 'Please enter a new password or confirm the password',
		reLogin: 'Password has been changed, please log in again',
		downloadContent: 'Download content',
		contentType: 'Content type',
		downloadDate: 'Download time',
		handle: 'operate',
		back: 'Back',
		del:'Delete',
		activityInfo: 'Activities',
		stateDate: 'Time-on',
		endDate: 'End Time',    
		address: 'Address',
		emtryInfo: 'Registration information',
		username: 'Name',
		phone: 'Phone',
		companyEmail: 'E-mail',
		company: 'Company',
		job: 'Job',
		industry: 'Industry',
		activityName: 'Activity Name',
		activityState: 'Activity State',
		projectName: 'Project Name',
		createDate: 'Create Date',
		basicInformation: 'Basic Information',
		companyName: 'Company Name',
		ipVisit: 'IP Visit',
		productGroup: 'Product Group',
		limitation: 'Limitation',
		partNumber: 'Part Number',
		incomeType: 'Income Type',
		projectManager: 'Project Manager',
		ownerGroup: 'Owner Group',
		ipSource: 'IP Source',
		productType: 'Product Type',
		ipType: 'IP Type',
		iPFamily: 'IP Family',
		technology: 'Technology',
		agreement: 'Protocol',
		architecture: 'Architecture',
		productCategory: 'Product Category',
		automaticNaming: 'Automatic Naming',
		contractMilestones: 'Contract Milestones',
		serialNumber: 'Serial Number',
		typesOf: 'Type',
		finalMSOfTheContract: 'Final MS of the contract',
		milestoneName: 'Milestone Name',
		milestoneDescription: 'Milestone Description',
		dependencyRelationship: 'Dependency Relationship',
		agreedCompletionTime: 'Agreed Completion Time',
		updateCompletionTime: 'Update Completion Time',
		expectedCompletionTime:'Expected Completion Time',
		actualFinish: 'Actual Finish Time',
		addMilestones: 'Add Milestones',
		deliveryStatus: 'Delivery Status',
		fileNameDescription: 'File Name/Description',
		milestoneNumber: 'Milestone Number',
		downloadBtn: 'Download',
		deliverables: 'Deliverables',
		uploaded: 'Uploaded',
		fileName:'File Name',
		version:"Version",
		versionNo:'Version',
		size:"Size",
		format:'Format',
		releaseTime:"Release Time",
		productName:"Product Name",
		purchasingDate:"Purchasing Date",
		downloadAccess:'Download Permission',
		documentAccess:'Document Permission',
		trainingAccess:'Training Permission',
		viewPermissions:'View Permissions',
		doyouwant:'What do you want to do?',
		iWantChoose:'I would like to choose',
		productsOfInterest:'Products of interest',
		iWantToModify:'I want to modify it',
		currentPassword:'Current password',
		iWantToView:'I would like to view',
		myDownloadHistory:'My download history',
		myRegistrationRecords:'My registration records',
		isThereAnyFeedbackOnMyWorkOrder:'Is there any feedback on my work order',
		myIPProductProgress:"My IP product progress",
		basicInformation:"Basic Information",
		isSubscribe:'Whether to subscribe to content push of interest',
		subscribed:'Subscribed',
		unsubscribe:'Unsubscribe',
		feedback:'Feedback',
		feedbackTime:'Feedback Time',
		feedbackIssues:'Feedback Issues',
		supplementaryQuestions:'Supplementary Questions',
		supplementaryAdd:'User Supplementation',
		replenishmentTime:'Replenishment Time',
		problemSummary:'Problem Summary',
		problemSummaryPlaceholder:'Please enter a title',
		problemDetails:'Details',
		problemDetailsPlaceholder:'Please describe your issue',
		uploadAttachments:'Upload attachments',
		addImages:'Add Picture',
		submit:'Submit',
		workOrderTitle:'Work Order Title',
		questionType:'Question type',
		problemStatus:'Problem status',
		submissionTime:'Submission Time',
		feedbackTime:'Feedback Time',
		operate:'Operate',
		unread:'Unread',
		read:"Read",
		message:"Message",
		messageName:'Message Title',
		messageTime:'Time',
		publishedDocuments:'Published Documents',
		installFiles:'Install Files',
		enterQuestion: 'Please enter an overview of the problem',
		enterDetail: 'Please enter a detailed description',
		createDate: 'Creation date',
		question:'Problem',
		applay:"UVOS reply",
		workOrderId:"Work Id",
		process:"Process",
		saler:"Sales",
		ipName:"IP Name",
		manager:"Manager",
		protocol:"Protocol"
	}
}

export default en_US